import CouponDetailPage from './CouponDetailPage'
export default CouponDetailPage